<template>
  <div class="">
    <h3>Preparation:</h3>
    <div class="container pt-3 m-auto text-left ">
       
      <form id="form" autocomplete="off" class="form-horizontal" @submit.stop.prevent="validateBeforeSubmit">

        
        <b-row v-if="item">
          <b-col cols="12">

            <b-form-file v-validate.persist="{ required: true }" name="archivo" required
              v-model="item.archivo" 
              :state="!item.archivo ? null : (getExtFile(item.archivo.name) == 'pdf' ? true : false)"
              placeholder="Elige un archivo o suéltalo aquí..."
              drop-placeholder="Suelta el archivo aquí..." accept=".pdf">
            </b-form-file>

          </b-col>
        </b-row>

        <b-row class="mb-3 mt-2">
          <b-col cols="6">
            <button class="btn btn-block btn-secondary" type="button" @click="cerrar">Cerrar</button>
          </b-col>
          <b-col cols="6">
            <button class="btn btn-block btn-success" type="submit">Guardar</button>
          </b-col>
        </b-row>
      </form>
      
    </div>
  </div>
  
</template>


<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  
  export default {
    name: 'PreparationNuevo',
    components: {
      
    },
    props:{
      tema_id:String
    },
    data () {
      return {
        item : null,
      }
    },
    mounted () {
      this.item = this.itemVacio
    },
    
    methods:{
        ...mapActions({
            crear: 'temas_adicional/crear',
            setWarning: 'setWarning',
        }),
      ...mapMutations({
        
      }),
      
      validateBeforeSubmit () {
        if (this.item.archivo && this.getExtFile(this.item.archivo.name) != "pdf") {
          this.item.archivo = null;
        }
        this.$validator.validateAll().then(result => {
          if (!result) {
            console.log('validateBeforeSubmit error')
          } else {
            console.log('validateBeforeSubmit no error')

            const form = new FormData();
            form.append("tema_id", this.tema_id)
            form.append("tipo", this.item.tipo)
            form.append("archivo", this.item.archivo, this.item.archivo.name)
            
            this.crear(form).then(result =>{
                this.setWarning('Preparation created', { root: true }).then(()=>{
                  this.$emit("actualizar")
                  this.cerrar();
              })
            }).catch(error=>{
              //todo probar si se puede quitar
              console.error("Preparacion error result:", error)
            })
          }
        })
      },
      cerrar() {
        this.$emit("cerrar")
      },
      getExtFile(filename) {
        let info = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename) : undefined;
        if (info && info.length) {
          return info[0];
        }
        return undefined;
      },

    },
    computed:{
      ...mapState({
        detalle: state => state.temas.detalle, 
        warning: state => state.warning,
      }),

      itemVacio(){
        return {
          tema_id : this.tema_id,
          tipo : "preparation",
        }
      },
      tema() {
        if (this.detalle[this.tema_id]) {
          return this.detalle[this.tema_id];
        }
        return null;
      },
      
      
    }
    
  }
</script>

<style scope>

  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
</style>
